module.exports = __webpack_public_path__ + "static/media/area-stacked-icon.420c2a6c.svg";